import React from "react";
import { Box, Flex, Text, Grid } from "@chakra-ui/react";
import Banner from "../../assets/homeImage/banner.png";
import GradientTextWithStroke from "./index.js";
import TextBG from "../../assets/homeImage/text-bg.png";

const How = () => {
  return (
    <Box bg="#3A005E" overflowX="hidden" >
      {/* Banner */}
      <Box
        bgImage={`url(${Banner})`}
        bgSize="cover"
        bgPosition="center"
        w="100%"
        h={{ base: "300px", md: "469px" }}
        color="white"
        // pr="100px"
      >
       <Flex direction="column" justify="center" align="center" h="100%">
  <Box ml={{ base: 0, md: "50%" }} textAlign={{ base: "center", md: "right" }} >
    <GradientTextWithStroke
      text="How It Works"
      desktopFontSize={70}
      mobileFontSize={60}
      strokeColor="#5c2d06"
      strokeWidth={5}
      gradientStops={[
        { offset: "25%", color: "#FAECA4" },
        { offset: "100%", color: "#B5763A" },
      ]}
    />
    <Text
      fontSize={{ base: "16px", md: "25px" }}
      mt={4}
      fontStyle="italic"
      fontWeight="500"
      // letterSpacing="0.2em"
      mr="130px"
    >
      Your Game. Your Rules. Your Rewards.
    </Text>
  </Box>
</Flex>

      </Box>

      {/* Correct centering with Flex */}
      <Text color="#A1A1A1" fontSize={{base:"20px", md:"30px"}} textAlign={"justify"} p={{base:"50px", md:"100px"}}>Whether you’re a sports strategist or a casual thrill-seeker, Winnsta is designed to make your journey from registration to rewards fast, fun, and full of adrenaline. Here's how you dive into the action</Text>
        <Text color="#FFFFFF" fontSize={"35px"} textAlign={"center"}>Step-by-Step to Glory:</Text>
      <Flex justify="center" px={{ base: 4, md: 0 }} mt={12} mr={{base:0, md:"25px"}}>
        <Grid
          templateColumns={{ base: "1fr", md: "410px 860px" }}
          gap={6}
          w="full"
          maxW={{ base: "100%", md: "1270px" }} // EXACT match to your 410+860 = 1270px
        >
          {/* LEFT COLUMN */}
          <Box w="100%">
            <Box {...cardStyle} h={{ base: "auto", md: "445px" }}>
              <Text {...titleStyle}>Sign Up & Suit Up</Text>
              <Text {...descStyle}>
                Create your account using mobile/email. Gear up with a custom avatar and choose your unique nickname – this is your identity in the Galaxy.
              </Text>
            </Box>

            <Box {...cardStyle} h={{ base: "auto", md: "571px" }} mt={6}>
              <Text {...titleStyle}>Join A Contest Or Battle</Text>
              <Text {...descStyle}>
                Select from free or paid contests:{"\n"}• Daily battles{"\n"}• Head-to-head duels{"\n"}• Mega leagues{"\n"}• Time-limited contests{"\n"}Each contest shows prize pool, difficulty level, entry fee, and number of players. Jump in!
              </Text>
            </Box>

            <Box {...cardStyle} h={{ base: "auto", md: "309px" }} mt={6}>
              <Text {...titleStyle}>Level Up & Earn More</Text>
              <Text {...descStyle}>
                Unlock achievements, hit streaks, refer friends, and reach new gaming tiers. More power = More perks.
              </Text>
            </Box>
          </Box>

          {/* RIGHT COLUMN */}
          <Box w="100%">
            <Box {...cardStyle} h={{ base: "auto", md: "420px" }}>
              <Text {...titleStyle}>Pick Your Playground</Text>
              <Text {...descStyle}>
                Choose between two electrifying gaming zones:{"\n\n"}
                <Text as="span" color="white" >
                  Fantasy Sports–{" "}
                </Text>
                Draft your dream team in Cricket, Football, or Kabaddi and earn points in real-time based on actual match performance.
                {"\n\n"}
                <Text as="span" color="white">
                  Casual Battles–{" "}
                </Text>
                Enter quick-fire skill games like 8 Ball Pool, Ludo, Fruit Slice, and more. Compete solo or challenge others.
              </Text>
            </Box>

            <Box {...cardStyle} h={{ base: "auto", md: "271px" }} mt={6}>
              <Text {...titleStyle}>Play With Passion</Text>
              <Text {...descStyle}>
                Your performance drives your progress. In Fantasy, it’s about smart picks and captaincy. In Casual Battles, it’s about speed, accuracy, and strategy. Leaderboards update LIVE. Feel the rush every second.
              </Text>
            </Box>

            <Box {...cardStyle} h={{ base: "auto", md: "230px" }} mt={6}>
              <Text {...titleStyle}>Win Big. Instantly.</Text>
              <Text {...descStyle}>
                Stand tall on the leaderboard to claim your prize. Payouts are credited instantly to your Winnsta wallet. Redeem for more matches or withdraw to your bank or UPI-linked wallet.
              </Text>
            </Box>

            <Box {...cardStyle} h={{ base: "auto", md: "382px" }} mt={6}>
              <Text {...titleStyle}>Why You’ll Love It</Text>
              <Text {...descStyle}>
                Instant Real-Money Wins – No waiting. No drama.{"\n"}Fast & Fair Gameplay – Skill-based and hot-paced.{"\n"}Seasonal Leagues & Events – Special IPL, World Cup, or festival-themed reward ladders.{"\n"}Refer & Earn – Bring friends, earn bonuses every time they play.{"\n"}Play Anytime, Anywhere – 24×7 access with lightweight, mobile-first design.
              </Text>
            </Box>
          </Box>

          {/* FULL WIDTH LAST BOX */}
          <Box gridColumn={{ md: "1 / span 2" }} w="100%">
            <Box {...cardStyle} w="100%" h={{ base: "auto", md: "226px" }} mt={1}>
              <Text {...titleStyle}>Pro Tip:</Text>
              <Text {...descStyle}>
                Stay tuned for live push notifications of hot contests. Use in-game analytics to make smart choices. The more you play, the more exclusive games you unlock.
              </Text>
            </Box>
          </Box>
        </Grid>
      </Flex>

      {/* Bottom Text */}
      <Text
        textAlign="center"
        fontSize={{ base: "20px", md: "28px" }}
        mt={12}
        fontStyle="italic"
        color="#D9982A"
      >
        Play Bold. Win Smart. Rule Winnsta.
      </Text>
      <Text
        textAlign="center"
        fontSize={{ base: "20px", md: "28px" }}
        mt={2}
        pb={10}
        color="white"
      >
        Your journey from rookie to legend starts here. Are you game?
      </Text>
    </Box>
  );
};

/// Shared card border style
const cardStyle = {
  flex: 1,
  p: { base: 4, md: 6 },
  borderRadius: "13px",
  position: "relative",
  overflow: "hidden",
  bgImage: `url(${TextBG})`,
  bgSize: "cover",
  bgPosition: "center",
  bgRepeat: "no-repeat",
  _before: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: "13px",
    padding: "2px",
    background:
      "linear-gradient(235.22deg, rgba(255, 209, 153, 0.1) -31.4%, #D9982A -12.83%, rgba(255, 209, 153, 0.1) 6.39%, #D9982A 24.96%, rgba(255, 209, 153, 0.1) 46.73%, #D9982A 69.15%, rgba(255, 209, 153, 0.1) 96.69%)",
    WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    pointerEvents: "none",
    zIndex: 2, // border sits on top
  },
};

const titleStyle = {
  fontSize: { base: "20px", md: "30px" },
  fontWeight: "500",
  mb: 2,
  color: "#D9982A",
};

const descStyle = {
  fontSize: { base: "16px", md: "28px" },
  color: "#FFFFFFCC",
  whiteSpace: "pre-line",
};

export default How;
